import { render, staticRenderFns } from "./addWordDialog.vue?vue&type=template&id=582b40f5&scoped=true&lang=pug"
import script from "./addWordDialog.vue?vue&type=script&lang=js"
export * from "./addWordDialog.vue?vue&type=script&lang=js"
import style0 from "./addWordDialog.vue?vue&type=style&index=0&id=582b40f5&prod&lang=scss&scoped=true"
import style1 from "./addWordDialog.vue?vue&type=style&index=1&id=582b40f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b40f5",
  null
  
)

export default component.exports